module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('h1', {
    attrs: {
      "id": "_idParaDest-8",
      "title": "Introduction"
    }
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor011"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor012"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor013"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor014"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor015"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor016"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page13",
      "title": "13"
    }
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "_idParaDest-9"
    }
  }, [_vm._v("INTRODUCTION")]), _vm._v(" "), _c('div', {
    staticClass: "chding"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/4.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "first-words"
  }, [_vm._v("IN RECENT DECADES GOD HAS MADE")]), _vm._v(" a comeback in philosophy departments and leading publishing houses. One atheist philosopher, Quentin Smith, has said that philosophy is becoming “denaturalized.” A renaissance in Christian philosophy—along with the emergence of philosophy of religion as a discipline—has been a blessed development. However, in the mid-twentieth century this philosophical light was considerably dimmer.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("In the fall of 1993, philosopher William Lane Craig and I had the privilege of meeting the iconic atheist philosopher Paul Edwards in his New York City apartment. There were a few memorable moments, like when Edwards kicked over his glass of wine on the carpet, and we observed an oddity on his apartment wall—an electric restroom hand dryer to help alleviate his neck pain. Edwards recounted how inspirational Bertrand Russell’s essay “Why I Am Not a Christian” had been to him over the course of his philosophical career. This was quite a surprise to us, since Russell’s arguments there are weak and sophomoric. Yet, Edwards told us, whenever he felt oppressed by some philosophical or ideological constraints, he would reread Russell’s essay to help “throw off the chains” and—raising both fists in the air—“experience freedom!”")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor017"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor018"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor019"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor020"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor021"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor022"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor023"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor024"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor025"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor026"
    }
  }), _c('a', {
    attrs: {
      "id": "_idTextAnchor027"
    }
  })]), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page14",
      "title": "14"
    }
  }), _vm._v("Back in 1967, the Enlightenment-style "), _c('i', {
    staticClass: "i"
  }, [_vm._v("Encyclopedia of Philosophy")]), _vm._v(" first appeared in print, edited by Edwards. He acknowledged that his own atheistic “ideological commitment” gave shape to this project, which was undertaken in the spirit of such biting critics of religion as Voltaire, Diderot, Hume and Russell. In a delicious twist of irony, Christian philosopher Alvin Plantinga’s sophisticated, groundbreaking book "), _c('i', {
    staticClass: "i"
  }, [_vm._v("God and Other Minds")]), _vm._v(" was published that same year. Plantinga’s book, atheist philosopher Quentin Smith observed, helped pave the way for the quiet revolution in Christian philosophy that followed. Another irony is this: in 1996 a supplement to Edwards’s "), _c('i', {
    staticClass: "i"
  }, [_vm._v("Encyclopedia")]), _vm._v(" was published to incorporate the many developments in the field since 1967. This supplement took a decidedly more theistic and religious turn, much to Edwards’s dismay."), _c('span', {
    staticClass: "notesbodyref"
  }, [_c('span', {
    attrs: {
      "id": "footnote-001-backlink"
    }
  }, [_c('span', {
    staticClass: "_idFootnoteLink _idGenColorInherit",
    attrs: {
      "href": "#/Text/notes#footnote-001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("There were other encyclopedic developments around the same time. In 1995 the online "), _c('i', {
    staticClass: "i"
  }, [_vm._v("Stanford Encyclopedia of Philosophy")]), _vm._v(" project was launched, and in 1998 the present gold-standard—the "), _c('i', {
    staticClass: "i"
  }, [_vm._v("Routledge Encyclopedia of Philosophy")]), _vm._v(", edited by Edward Craig—was published. Both of these works are considerably more sympathetic to theism, and many of their contributors are Christians. Sophisticated books in philosophy promoting or sympathetic to theism are regularly published by mainstream presses such as Oxford, Cambridge, Wiley, Routledge and Ashgate.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_vm._v("Of course, we should avoid triumphalism and always put our trust in the Lord rather than in historical trends, however "), _c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page15",
      "title": "15"
    }
  }), _vm._v("encouraging they may be. I offer this brief historical sketch to encourage believers interested in pursuing philosophy—as well as Christian philosophers who have been engaged in the task for years—that Christians doing good work in philosophy have earned the respect of other philosophers and a rightful place in the academy.")]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    staticClass: "pagebreak",
    attrs: {
      "id": "page16",
      "title": "16"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08eeb89c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/intro.vue
// module id = 69
// module chunks = 0